import { GET_CERTIFICATES } from '../actions/types';

export default (
    state = { loaded: false, section: { title: '', subtitle: '' }, data: { certificates: [] } },
    { type, payload }
) => {
    switch (type) {
        case GET_CERTIFICATES: {
            const { loaded, section, data } = payload;

            return {
                ...state,
                loaded,
                section,
                data
            };
        }

        default:
            return state;
    }
};
